import request from '@/utils/request'

// 查询咨询室详情
export const describe = (appointmentId) =>
  request({
    url: '/consultMeeting/describe?appointmentId=' + appointmentId,
    method: 'get'
  })

// 查询当前参会人员记录
export const queryAttendRecords = (meetingId) =>
  request({
    url: '/consultMeeting/queryAttendRecords?meetingId=' + meetingId,
    method: 'get'
  })

// 查询当前登陆人信息
export const getUserEmployeeInfoById = (params) =>
  request({
    url: '/user/getUserEmployeeInfoById',
    method: 'get',
    params
  })

// 聊天室-查询数据
export const messageList = (params) =>
  request({
    url: '/consultMeeting/message/list',
    method: 'get',
    params
  })

// 聊天室-发送消息
export const consultMeetingMessage = (data) =>
  request({
    url: '/consultMeeting/message',
    method: 'post',
    data
  })
// 聊天室-全体静音
export const switchMicrophone = (data) =>
  request({
    url: '/consultMeeting/switchMicrophone',
    method: 'post',
    data
  })
// 聊天室-全体静音
export const switchCamera = (data) =>
  request({
    url: '/consultMeeting/switchCamera',
    method: 'post',
    data
  })


// 咨询室详情-接受预约
export const consultMeetingAccept = (data) =>
  request({
    url: '/consultMeeting/accept',
    method: 'post',
    data
  })

// 咨询室详情-接受预约
export const consultMeetingRefuse = (data) =>
  request({
    url: '/consultMeeting/refuse',
    method: 'post',
    data
  })



// 修改预约记录-列表数据
export const changeTimeList = (appointmentId) =>
  request({
    url: '/consultMeeting/changeTime/list?appointmentId=' + appointmentId,
    method: 'get'
  })
// 修改预约记录-同意
export const changeTimePass = (data) =>
  request({
    url: '/consultMeeting/changeTime/pass',
    method: 'post',
    data
  })

// 修改预约记录-拒绝
export const changeTimeRefuse = (data) =>
  request({
    url: '/consultMeeting/changeTime/refuse',
    method: 'post',
    data
  })

// 修改预约记录-建议新时间
export const changeTimePropose = (data) =>
  request({
    url: '/consultMeeting/changeTime/propose',
    method: 'post',
    data
  })

// 延长时间-获取可延长范围
export const getAvailableTimes = (appointmentId) =>
  request({
    url: '/consultMeeting/getAvailableTimes?appointmentId=' + appointmentId,
    method: 'get'
  })

// 延长时间-确认延长
export const addTimes = (data) =>
  request({
    url: '/consultMeeting/addTimes',
    method: 'post',
    data
  })

// 修改时间-确认修改
export const changeTime = (data) =>
  request({
    url: '/consultMeeting/changeTime',
    method: 'post',
    data
  })

// 取消预约-确认取消
export const consultMeetingCancel = (data) =>
  request({
    url: '/consultMeeting/cancel',
    method: 'post',
    data
  })

// 关闭-确认关闭
export const consultMeetingClose = (data) =>
  request({
    url: '/consultMeeting/close',
    method: 'post',
    data
  })

// 举报-确认举报
export const reportCreate = (data) =>
  request({
    url: '/report/create',
    method: 'post',
    data
  })

// 行为记录-查询列表数据
export const queryBehaviorRecords = (appointmentId) =>
  request({
    url: '/consultMeeting/queryBehaviorRecords?appointmentId='+appointmentId,
    method: 'get'
  })

// 回看录像
export const videoRecords = (appointmentId) =>
  request({
    url: '/consultMeeting/videoRecords?appointmentId='+appointmentId,
    method: 'get'
  })

// 进房心跳请求
export const consultMeetingHealth = (data) =>
  request({
    url: '/consultMeeting/health',
    method: 'post',
    data
  })
